import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const FloatingWhatsApp = () => {
  const { t } = useTranslation();

  return (
    <a
      href="https://wa.me/385913782937"
      className="floating-whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('floatingWhatsApp.ariaLabel')}
    >
      <FaWhatsapp />
    </a>
  );
};

export default FloatingWhatsApp;